<template>
  <div class="wrapper">
    <transition name="fade">
      <div class="overlay">
        <div class="spinner-container">
          <div class="spinner" />
          <img class="logo" src="@/assets/1home-dark-logo.png" />
        </div>
        <span v-if="$props.text" class="text">{{ $props.text }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: {
    text: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activeLoadings: []
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../../common/_variables.scss";
.wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  z-index: 1000;
  .spinner-container {
    position: relative;
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    .spinner {
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      border: 2px solid #ebebeb;
      border-top: 2px solid $color-primary;
      animation: rotate 1s linear infinite;
    }
    .logo {
      width: 70%;
    }
  }
  .text {
    font-size: 0.9rem;
    font-weight: bold;
    margin-top: 20px;
    padding: 0 15px;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
